export const LOTTIE_SPEED = 0.8;

export const SWIPER_SPACE_BETWEEN = 14;

export const SWIPER_BREAKPOINTS = {
	600: {
		slidesPerView: 'auto' as const,
		spaceBetween: SWIPER_SPACE_BETWEEN
	},
	1280: {
		slidesPerView: 5,
		spaceBetween: SWIPER_SPACE_BETWEEN
	}
};
